import React from "react";
import { HeaderHLPure, PromotionalFooterPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import './my-flows-administration.css';

const MyFlowsAdministrationView = (props) => {
    let { 
        headerTitle
    } = props

    return(
        <div className="myFlowsAdministrationView-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="myFlowsAdministrationView-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="myFlowsAdministrationView-body">
                        <h1>Pantalla de administración de mis flujos</h1>
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export { MyFlowsAdministrationView as default }